import styled from 'styled-components';
import { primaryColor, primaryColorWeak } from '../../config/colors';

const inPixels = (n) => `${n}px`;

// const drawCheckmark = (size) => ({
//   left: inPixels(size / 3),
//   top: inPixels(size / 5),
//   width: inPixels(size / 5),
//   height: inPixels(size / 2.5),
//   border: 'solid #20e2ab',
//   borderWidth: `0 ${inPixels(size / 8)} ${inPixels(size / 8)} 0`,
//   transform: `rotate(45deg)`,
// });

const drawCheckmark = (size) => ({
  left: inPixels(size / 5),
  top: `-${inPixels(size / 8)}`,
  width: inPixels(size / 2.3),
  height: inPixels(size / 1.2),
  border: 'solid #20e2ab',
  borderWidth: `0 ${inPixels(size / 8)} ${inPixels(size / 8)} 0`,
  borderRadius: inPixels(size / 12),
  transform: `rotate(45deg)`,
});

export const Wrapper = styled.label`
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 13px;
  user-select: none;
  width: ${({ width }) => width};
  min-height: ${({ size }) => `${size}px`};
  padding-left: ${({ size }) => `calc(${size}px + 4px)`};
  display: flex;
  align-items: center;
  line-height: 1.5;

  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  & .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  & .checkmark {
    border-radius: 2px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: ${({ size }) => `${size}px`};
    width: ${({ size }) => `${size}px`};
    border: 2px solid ${primaryColor};
    transition: background-color 0.2s ease-out;
  }

  & input:checked ~ .checkmark {
  }

  & input:disabled ~ .checkmark {
    opacity: 0.7;
  }

  & .checkmark:after {
    display: ${({ checked }) => (checked ? 'block' : 'none')};
  }

  & .checkmark:after {
    ${({ size }) => drawCheckmark(size)}
  }

  & .checkmark:hover {
    background-color: ${primaryColorWeak};
  }
`;
